<template>
  <v-app>
    <v-content>
      <div class="row" style="height: 100%; margin: 0 !important;">
        <div class="column" style="background-color:#13459c;">
          <v-container fluid fill-height>
            <v-layout align-center justify-center>
              <img src="../assets/img/logo.svg" height="95" width="270">
            </v-layout>
          </v-container>
        </div>
        <div class="column" style="background-color:#fff;">
          <v-container fluid fill-height>
            <v-layout align-center justify-center>
              <v-card class="elevation-0" width="600">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="text-h5">
                      Enterprise Dashboard
                    </v-list-item-title>
                    <v-list-item-subtitle>Forgot password</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-card class="elevation-0">
                  <v-alert v-if="showError" dense outlined type="error">{{error}}</v-alert>
                  <template v-if="!sended">
                    <v-card-text>
                      <v-form ref="forgotPasswordForm">
                        <v-text-field :disabled="inProgress" required v-model="email" label="Email" type="text" ref="email" :rules="[v => !!v || '', v => /.+@.+/.test(v) || '']"></v-text-field>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <router-link :to="{ name: 'Login' }" class="blue--text login-link mr-4">Login</router-link>
                      <v-btn tile depressed color="blue white--text" :loading="inProgress" @click="submit" :disabled="!email">Reset password</v-btn>
                    </v-card-actions>
                  </template>
                  <template v-if="sended">
                    <v-card-text class="pb-3">Check your inbox for a password reset email</v-card-text>
                  </template>
                </v-card>
              </v-card>
            </v-layout>
          </v-container>
        </div>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import { FORGOT_PASSWORD } from '@/store/actions.type';

export default {
  name: 'forgot-password',
  data () {
    return {
      email: '',
      inProgress: false,
      error: null,
      showError: false,
      sended: false,
    };
  },
  methods: {
    async submit() {
      if (this.$refs.forgotPasswordForm.validate()) {
        this.inProgress = true;
        this.showError = false;
        this.error = '';

        try {
          await this.$store.dispatch(FORGOT_PASSWORD, { email: this.email, dashboardUser: true });
          this.inProgress = false;
          this.sended = true;
        } catch(error) {
          if (error && error.data && error.data.value) {
            this.error = `${error.data.value}. Please contact support@planetverify.com`;
          } else {
            this.error = 'Something went wrong. Please contact support@planetverify.com';
          }
          this.inProgress = false;
          this.showError = true;
        }
      } else {
        this.showError = true;
        this.error = 'Please enter a valid email address';
      }
    },
    resend() {
      this.sended = false;
      this.inProgress = false;
      this.email = '';
      this.showError = false;
    },
  },
}
</script>

<style>
.login-link {
  text-decoration: none;
}

.login-link:hover {
  text-decoration: underline;
}

.column {
  float: left;
  width: 50%;
  padding: 10px;
  min-height: 100%;
}

.row:after {
  content: "";
  display: table;
  clear: both;
}
</style>
